import { mount } from "@vue/test-utils";
import Referidos from "@/views/Referidos";

jest.mock("@/views/Referidos", () => ({
  ...jest.requireActual("@/views/Referidos"),
  __esModule: true,
  default: {
    email: "mockedValue@.com"
  }
}));

describe("Referidos test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(Referidos);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Referidos", () => {
    expect(wrapper).toBeDefined();
  });
});
